import { v1 as uuid } from 'uuid';
import { ComplexValue } from 'ui/common/types';
import { MalwareScanStatusValue } from 'ui/file-uploader/malware-scan-status';

interface UploadedFile{
  id?: number; // No. column of attachment row
  blobId?: number; // Blob id of attachment row if the file has been uploaded
  name: string;
  title: string;
  type: string;
  size: number;
  thumbnailSize?: number;
  attachedBy?: ComplexValue<number>;
  attachedAt?: Date;
  mainImage?: boolean;
  malwareScanStatus?: MalwareScanStatusValue;
}

export enum BlobMalwareScanStatus 
{
    Unknown,
    Safe,
    Malicious,
    WaitingForScan,
    NotScanned,
    Error
}

export interface ProgressFile extends UploadedFile{
  uploaded?: number;
  uploadRate?: number;
  isWaiting?: boolean;
  uniqueId: string;
  file?: File;
  xhr?: XMLHttpRequest;
}

export const makeProgressFile = (file: File): ProgressFile => {
  return {
    file,
    name: file.name,
    title: file.name.substring(0, file.name.lastIndexOf('.')),
    type: file.type,
    size: file.size,
    uploaded: 0,
    uploadRate: 0,
    isWaiting: true,
    uniqueId: uuid()
  };
};

export const makeItemPropsFromProgressFile = (progressFile: ProgressFile) => {
  return {
    id: -1,
    key: progressFile.uniqueId,
    title: progressFile.title,
    name: progressFile.name,
    extension: progressFile.name.substring(progressFile.name.lastIndexOf('.')),
    type: progressFile.type,
    size: progressFile.size,
    attachedBy: progressFile.attachedBy,
    attachedAt: progressFile.attachedAt,
    isWaiting: progressFile.isWaiting,
    uploaded: progressFile.uploaded,
    uploadRate: progressFile.uploadRate
  };
};

export const addItemPropsFromUploadedFile = (props: any, uploadedItem: UploadedFile) => {
  return {
    ...props,
    ...{
      id: uploadedItem.id,
      blobId: uploadedItem.blobId,
      title: uploadedItem.title,
      thumbnailSize: uploadedItem.thumbnailSize,
      attachedBy: uploadedItem.attachedBy,
      attachedAt: uploadedItem.attachedAt,
      malwareScanStatus: uploadedItem.malwareScanStatus,
      isWaiting: false
    }
  };
};

export const makeItemPropsFromUploadedFile = (uploadedFile: UploadedFile) => {
  return {
    id: uploadedFile.id,
    blobId: uploadedFile.blobId,
    key: uploadedFile.id.toString(),
    title: uploadedFile.title,
    name: uploadedFile.name,
    extension: uploadedFile.name && uploadedFile.name.substring(uploadedFile.name.lastIndexOf('.')),
    type: uploadedFile.type,
    size: uploadedFile.size,
    thumbnailSize: uploadedFile.thumbnailSize,
    attachedBy: uploadedFile.attachedBy,
    attachedAt: uploadedFile.attachedAt,
    isWaiting: false,
    uploaded: uploadedFile.size,
    uploadRate: 0,
    mainImage: uploadedFile.mainImage,
    malwareScanStatus: uploadedFile.malwareScanStatus
  };
};
